module.exports = "https://assets.meiaentrada.org.br/static/media/DNE-MEIA ENTRADA.2d21d3ec.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DNE-MEIA ENTRADA.webp
// module id = 501
// module chunks = 0